module.exports = __webpack_public_path__ + "img/promo_materials.8abce42.2e58a228.png";